/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { tournamentServer } from 'network-utils';

const tournamentsApi = tournamentServer.TournamentsAPIs;
export const getUpcomingTournaments = 'upcoming-tournaments';
export const getCoreUpcomingTournaments = 'core-upcoming-tournaments';
export const getPastTournaments = 'past-tournaments';
export const getTournamentUsersLeaderboard = 'tournaments-users-leaderboard';
const getTournamentResults = 'tournaments-results';

export const useGetUpcomingTournaments = (token: string, isTournamentGamePackageEnabled: boolean) => {
    return useQuery([getUpcomingTournaments, token], () => tournamentsApi.getUpcomingTournaments(token), {
        cacheTime: 0,
        enabled: !!token && !isTournamentGamePackageEnabled
    });
};

export const useGetPastTournaments = (token: string, isTournamentGamePackageEnabled: boolean) => {
    return useQuery([getPastTournaments, token], () => tournamentsApi.getPastTournaments(token), {
        cacheTime: 0,
        enabled: !!token && !isTournamentGamePackageEnabled,
        keepPreviousData: true
    });
};

export const useGetTournamentUsersLeaderboard = (
    token: string,
    enableQuery: boolean,
    offset: number,
    limit: number,
    searchString?: string,
    tournamentUuid?: string
) => {
    return useQuery(
        [getTournamentUsersLeaderboard, token, offset, limit, tournamentUuid, searchString],
        () => tournamentsApi.getTournamentUsersLeaderboard(token, offset, limit, tournamentUuid, searchString),
        {
            cacheTime: 0,
            keepPreviousData: true,
            enabled: enableQuery && Boolean(tournamentUuid) && !!token
        }
    );
};

export const useGetTournamentResult = (
    token: string,
    tournamentUuid: string,
    isTournamentGamePackageEnabled: boolean
) => {
    return useQuery([getTournamentResults, token], () => tournamentsApi.getTournamentResults(token, tournamentUuid), {
        cacheTime: 0,
        enabled: !!token && !!tournamentUuid && !isTournamentGamePackageEnabled
    });
};
